"use strict";
//
// Copyright © 2023 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceNode = void 0;
const core_1 = require("@tiptap/core");
const utils_1 = require("./utils");
/**
 * @public
 */
exports.ReferenceNode = core_1.Node.create({
    name: 'reference',
    group: 'inline',
    inline: true,
    selectable: true,
    addAttributes() {
        return {
            id: (0, utils_1.getDataAttribute)('id'),
            objectclass: (0, utils_1.getDataAttribute)('objectclass'),
            label: (0, utils_1.getDataAttribute)('label'),
            fixed: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-fixed') === 'true',
                renderHTML: (attributes) => {
                    if (attributes.fixed !== true) {
                        return {};
                    }
                    return {
                        'data-fixed': 'true'
                    };
                }
            }
        };
    },
    addOptions() {
        return {
            suggestion: { char: '@' },
            HTMLAttributes: {}
        };
    },
    parseHTML() {
        return [
            {
                priority: 60,
                tag: 'span[data-type="reference"]',
                getAttrs
            },
            {
                priority: 60,
                tag: 'a[data-type="reference"]',
                getAttrs
            }
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return [
            'span',
            (0, core_1.mergeAttributes)({
                'data-type': this.name,
                'data-id': node.attrs.id,
                'data-objectclass': node.attrs.objectclass,
                'data-label': node.attrs.label,
                class: 'antiMention'
            }, this.options.HTMLAttributes, HTMLAttributes),
            `${this.options.suggestion.char}${node.attrs.label ?? node.attrs.id}`
        ];
    }
});
function getAttrs(el) {
    const id = el.dataset.id?.trim();
    const label = el.dataset.label?.trim();
    const objectclass = el.dataset.objectclass?.trim();
    const fixed = el.getAttribute('data-fixed') === 'true';
    if (id == null || label == null || objectclass == null) {
        return false;
    }
    return {
        id,
        label,
        objectclass,
        fixed: fixed || null
    };
}
//# sourceMappingURL=reference.js.map